import { Modal, OverlayBackdrop, Textarea } from "@ds/ds-snam/react";
import { Button } from "@ds/ds-snam/react";
import { DsLayout,  UICommand } from "shared/constants";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "state/appStore";


interface ICancelBookingModalProps {
    type:string,
    onClose: (command?: UICommand) => void,
    saveData: ()=>void,
    codeIup?: string,
    editClosureText?: (closureText:string)=>void
}

const MyBookingModal: React.FC<ICancelBookingModalProps> = (props): JSX.Element => {


    const { t } = useTranslation(["b2b", "app"]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let tempTextValue = '';
    const inputTextChange = (inputEvent: Event) => {
        tempTextValue=(inputEvent as CustomEvent).detail.input.value;
        props.editClosureText!((inputEvent as CustomEvent).detail.input.value);
    }
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })

    return (
        <>
            <div style={{ zIndex: 1200, position: "relative", fontFamily: 'Lato, Lato-local, sans-serif' }}>
                <OverlayBackdrop />
                    <Modal
                        modalSize="medium"
                        iconExtra={false}
                        overlayIcon="icon-open-mail"
                        overlayDescriptionId="overlay-description"
                        is-gradient-color={false}
                        onCloseModal={() =>
                            props.onClose()
                        }
                    >

                        <div slot="title" style={{ background: '', height: '100px' }}>
                            <div style={{ width: 'fit-content', margin: '0 auto', color: '#db6100' }}>
                                <ds-icon
                                    id="arrowTopBar"
                                    icon={"icon-info-circle"}
                                    icon-size="xlarge"
                                    icon-filled="false"
                                ></ds-icon>
                            </div>
                        </div>

                        <div slot="text">
                            <div slot="title" style={{fontFamily:'Lato, Lato-local, sans-serif'}}>
                                <>
                                    <h2 className="ff-ubuntu ff-title-s ff-bold" style={{ margin: "0 auto",width:'fit-content',textAlign:'center',color: layoutMode===DsLayout.DARK_MODE?"white":"black" }} id="overlay-title">
                                        {props.type==='closureModal' ?
                                            t("booking.closureModal.0")/*<>Conferma chiusura</>*/
                                        :
                                            <>{props.type==='settingsMoveParameters'?
                                                t("booking.settings.0")
                                            :
                                                <>
                                                {props.type==='switchToCoolDownModal'?
                                                    t("booking.bookingSwitchToCoolDownModal.0")
                                                :
                                                    t("booking.bookingDeleteModal.6")/*Vuoi eliminare lo slot?*/
                                                }
                                                </>
                                                
                                            }
                                            </>
                                        }
                                    </h2> 
                                    <>
                                        <p style={{ margin: "0 auto",textAlign:'center',marginTop:'20px',color: layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                                            {props.type==='closureModal' ?
                                                t("booking.closureModal.1")/*Inserisci la motivazione per cui l'esito è negativo:*/
                                            :
                                                <>
                                                    {props.type==='settingsMoveParameters'?
                                                        t("booking.settings.1")
                                                    :
                                                    <>
                                                        {props.type==='switchToCoolDownModal'?
                                                            t("booking.bookingSwitchToCoolDownModal.1")
                                                        :
                                                            t("booking.bookingDeleteModal.0")
                                                        }
                                                    </>
                                                    }
                                                </>
                                            }
                                        </p>
                                        <p style={{ margin: "0 auto",textAlign:'center',color: layoutMode===DsLayout.DARK_MODE?"white":"black" }}>
                                            {props.type==='closureModal' ?
                                                t("booking.closureModal.2")/*Inoltreremo il messaggio al cliente e al commerciale Greenture*/
                                            :
                                                <>
                                                {props.type==='settingsMoveParameters'?
                                                    t("booking.settings.2")
                                                :
                                                <>
                                                        {props.type==='switchToCoolDownModal'?
                                                            <></>
                                                        :
                                                        t("booking.bookingDeleteModal.1")
                                                        }
                                                    </>
                                                }
                                                
                                                </>
                                            }
                                        </p>
                                    </>
                                 </>
                            </div>
                            {props.type==='closureModal' &&

                                <div slot="text" style={{width:'80%',margin:'0 auto',marginTop:'20px',color: layoutMode===DsLayout.DARK_MODE?"white":"black"}}>
                                    <Textarea
                                        textareaLabel={t("booking.closureModal.3")}//'Descrizione chiusura slot'
                                        textareaName="rejectFormTextAreaDelegation"
                                        textareaId="textareadelegationrejected-id"
                                        elementResetPair=""
                                        textareaDescription={t("booking.closureModal.4")}//"Caratteri"
                                        textareaStatus="default"
                                        textareaPlaceholder={t("booking.closureModal.5")}//"Inserisci qui la descrizione"
                                        textareaMaxChar={500}
                                        textareaRows={10}
                                        isDisabled={false}
                                        textAreaValue={tempTextValue}
                                        isReadonly={false}
                                        isExpandableVariant={false}
                                        isEditableVariant={false}
                                        showMaxChar={true}
                                        onInputChange={inputTextChange}
                                    ></Textarea>
                                </div>  
                            }
                        </div>

                        <div
                            slot="footer"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "8px",
                                alignItems: "center",
                                marginTop: '20px'
                            }}
                        >
                            <div style={{ margin: '0 auto', width: 'fit-content', }}>
                                <div style={{ margin: '0 auto', width: 'fit-content', float: 'left' }}>
                                    <Button
                                        buttonUIVariant="secondary"
                                        buttonSize="medium"
                                        buttonLabel={t('calendar.popups.buttons.6')}//'Annulla'
                                        onClickEvent={() => {
                                            props.onClose()
                                        }}
                                    ></Button>
                                </div>
                                
                                <div style={{ margin: '0 auto', width: 'fit-content', float: 'right', marginLeft: '10px' }}>
                                    <Button
                                        buttonSize="medium"
                                        buttonLabel={t('general.buttons.confirm', {ns:['app']})}//"Conferma"
                                        onClickEvent={() => {
                                            props.saveData()
                                        }}
                                    ></Button>
                                </div>
                                
                            </div>
                            
                        </div>
                    </Modal>
            </div>
        </>
    );
}

export default MyBookingModal;